import { Twitter, Linkedin } from "lucide-react";
import { cn } from "@/lib/utils";

interface Author {
  id: string;
  name: string;
  role: string;
  avatar: string;
  bio: string;
  social?: {
    twitter?: string;
    linkedin?: string;
  };
}

interface AuthorProfileProps {
  author: Author;
  className?: string;
}

export const AuthorProfile = ({ author, className }: AuthorProfileProps) => {
  return (
    <div className={cn("glass p-6 rounded-xl border border-border/50", className)}>
      <div className="flex items-start gap-4">
        <img
          src={author.avatar}
          alt={author.name}
          className="w-16 h-16 md:w-20 md:h-20 rounded-full object-cover border-2 border-sand/20"
        />
        
        <div className="flex-1">
          <div className="flex items-start justify-between gap-4 mb-2">
            <div>
              <h3 className="text-lg md:text-xl font-bold">{author.name}</h3>
              <p className="text-sm text-sand">{author.role}</p>
            </div>
            
            {author.social && (
              <div className="flex items-center gap-2">
                {author.social.twitter && (
                  <a
                    href={author.social.twitter}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-2 rounded-lg border border-border bg-background hover:bg-accent hover:text-sand transition-all duration-300"
                    aria-label="Twitter"
                  >
                    <Twitter className="w-4 h-4" />
                  </a>
                )}
                {author.social.linkedin && (
                  <a
                    href={author.social.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-2 rounded-lg border border-border bg-background hover:bg-accent hover:text-sand transition-all duration-300"
                    aria-label="LinkedIn"
                  >
                    <Linkedin className="w-4 h-4" />
                  </a>
                )}
              </div>
            )}
          </div>
          
          <p className="text-sm text-foreground/70 leading-relaxed">
            {author.bio}
          </p>
        </div>
      </div>
    </div>
  );
};
